import { Component, Vue } from 'vue-property-decorator'
import CBBG1010ViewModel from './CBBG1010ViewModel'
import CBBG1010Service from './CBBG1010Service'

import SessionStorageService from '@/common/SessionStorageService'
import CommonConstants from '@/common/CommonConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import TransportService from '@/common/TransportService'
import { fixedContent } from '@/assets/js/main.js'
@Component({
  name: 'CBBG1010',
  components: {}
  })
export default class CBBG1010Controller extends Vue {
  private isHasUrl = false
  private cbbg1010ViewModel: CBBG1010ViewModel = {
    contractInfo: {
      kiyakuYoyakuName: '',
      kiyakuYoyakuURL: '',
      kiyakuHonbunName: '',
      kiyakuHonbunURL: '',
      kiyakuHonbunBesshiName: '',
      kiyakuHonbunBesshiURL: ''
    },
    cntctNameFormal: '',
    cmpnyNameFormal: '',
    cntctUnitDiv: null
  }

  private cbbg1010Service = new CBBG1010Service()

  /**
   * 画面要素描画後処理
   */
  mounted() {
    fixedContent()
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const [cbba1010ResponseModel] = await Promise.all([
      this.cbbg1010Service.callAPICBBA1010(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CBBG1010, null, null)
    ])
    if (CommonUtil.isNotEmpty(cbba1010ResponseModel.contractInfo)) {
      this.cbbg1010ViewModel.contractInfo = cbba1010ResponseModel?.contractInfo
      if (
        (this.cbbg1010ViewModel.contractInfo.kiyakuYoyakuURL &&
          this.cbbg1010ViewModel.contractInfo.kiyakuYoyakuName) ||
        (this.cbbg1010ViewModel.contractInfo.kiyakuHonbunURL &&
          this.cbbg1010ViewModel.contractInfo.kiyakuHonbunName) ||
        (this.cbbg1010ViewModel.contractInfo.kiyakuHonbunBesshiURL &&
          this.cbbg1010ViewModel.contractInfo.kiyakuHonbunBesshiName)
      ) {
        this.isHasUrl = true
      }
    }
    const userInfo = JSON.parse(
      SessionStorageService.getItem(CommonConstants.USER_INFO)
    )

    this.cbbg1010ViewModel.cntctNameFormal = userInfo?.userInfo?.cntctNameFormal
    this.cbbg1010ViewModel.cmpnyNameFormal = userInfo?.userInfo?.cmpnyNameFormal
    this.cbbg1010ViewModel.cntctUnitDiv = userInfo?.userInfo?.cntctUnitDiv
  }

  /**
   * 規約（要約版）リンク押下
   * 規約（本文）リンク押下
   */
  private async openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }
}
